import { render, staticRenderFns } from "./DutyList.vue?vue&type=template&id=01475c42&scoped=true"
import script from "./DutyList.vue?vue&type=script&lang=js"
export * from "./DutyList.vue?vue&type=script&lang=js"
import style0 from "./DutyList.vue?vue&type=style&index=0&id=01475c42&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01475c42",
  null
  
)

export default component.exports